export const MAINTENANCE_CATEGORIES = [

  {
    value: "preventive",
    label: "Preventivo"
  },

  {
    value: "corrective",
    label: "Correctivo"
  },

  {
    value: "inspection",
    label: "Inspección"
  },

  {
    value: "other",
    label: "Otro"
  }

];